import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { useAuth } from "@/context/AuthContext";

export default function Connexion() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const [error, setError] = useState(false);
  const token = params.get("token");

  useEffect(() => {
    if (!token) { setError(true); return; }
    api.post("/auth/magic", { token }).then(() => {
      if (refresh) refresh();
      navigate("/compte");
    }).catch(() => setError(true));
  }, [token, navigate, refresh]);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="container page-content fade-in" data-testid="connexion-page">
        <div style={{ maxWidth: 520, margin: "0 auto", textAlign: "center", paddingTop: "6vh" }}>
          {error ? (
            <div data-testid="connexion-error">
              <div style={{ fontSize: 48 }} aria-hidden="true">⚠️</div>
              <h1 className="mt-6">Lien invalide ou expiré</h1>
              <p className="muted mt-4">Ton lien de connexion n'est plus valable. Connecte-toi avec l'email de ton paiement.</p>
              <button onClick={() => navigate("/retrouver")} data-testid="connexion-login-btn" className="btn-primary mt-8">Me connecter <span aria-hidden="true">→</span></button>
              <p className="muted text-sm mt-6">Besoin d'aide ? <a className="accent underline" href="mailto:support.idevorai@gmail.com">support.idevorai@gmail.com</a></p>
            </div>
          ) : (
            <div data-testid="connexion-loading">
              <div className="load40-bar mt-6" style={{ maxWidth: 260, margin: "2rem auto 0" }}><div className="load40-bar-fill" style={{ width: "60%" }} /></div>
              <p className="muted mt-6">Connexion à ton espace…</p>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
